import { useEffect, useState } from 'react';
import { TourBagStaticService } from '@/service';
import {
  FedExCupPlayer,
  InternalStatusLookup,
  Nationality,
  PlayerCollegeLookup,
  PlayerInternalStatuses,
  PlayerRegionLookup,
  PlayerStatusLookup,
  PlayerSupportLookup,
  PlayerYearLookup,
  Tour,
} from '@/api/models';

export const useEditPlayerInfo = () => {
  const [loading, setLoading] = useState(true);
  const [tours, setTours] = useState<Tour[]>([]);
  const [playerStatusLookups, setPlayerStatusLookups] = useState<PlayerStatusLookup[]>([]);
  const [playerRegionLookups, setPlayerRegionLookups] = useState<PlayerRegionLookup[]>([]);
  const [playerInternalStatuses, setPlayerInternalStatuses] = useState<PlayerInternalStatuses[]>([]);
  const [internalStatusLookups, setInternalStatusLookups] = useState<InternalStatusLookup[]>([]);
  const [nationalities, setNationalities] = useState<Nationality[]>([]);
  const [colleges, setColleges] = useState<PlayerCollegeLookup[]>([]);
  const [years, setYears] = useState<PlayerYearLookup[]>([]);
  const [supports, setSupports] = useState<PlayerSupportLookup[]>([]);
  const [fedExCupPlayers, setFedExCupPlayers] = useState<FedExCupPlayer[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const [tours, playerStatusLookups, playerRegionLookups, playerInternalStatuses, internalStatusLookups, nationalities, colleges, years, supports, fedExPlayers] = await Promise.all([
        TourBagStaticService.getTourData(),
        TourBagStaticService.getPlayerStatusLookups(),
        TourBagStaticService.getPlayerRegionLookups(),
        TourBagStaticService.getPlayerInternalStatuses(),
        TourBagStaticService.getInternalStatusLookups(),
        TourBagStaticService.getNationalities(),
        TourBagStaticService.getPlayerCollegeLookups(),
        TourBagStaticService.getPlayerYearLookups(),
        TourBagStaticService.getPlayerSupportLookups(),
        TourBagStaticService.getFedExCupPlayerData(),
      ]);
      setTours(tours);
      setPlayerStatusLookups(playerStatusLookups);
      setPlayerRegionLookups(playerRegionLookups);
      setPlayerInternalStatuses(playerInternalStatuses);
      setInternalStatusLookups(internalStatusLookups);
      setNationalities(nationalities);
      setColleges(colleges);
      setYears(years);
      setSupports(supports);
      setLoading(false);
      setFedExCupPlayers(fedExPlayers);
    };
    fetchData();
  }, []);

  return {
    loading,
    tours,
    playerStatusLookups,
    playerRegionLookups,
    playerInternalStatuses,
    internalStatusLookups,
    nationalities,
    colleges,
    years,
    supports,
    fedExCupPlayers,
  };
};
